import { ProgressClockSVGIcon } from "components/SVGIcons";
import styles from "./style.module.scss";

export default function HomePendingStatusCard() {
  return (
    <div className={styles.pendingStatusCard}>
      <div className={styles.text}>
        <span className="text-sm">Application Status</span>
        <span className="text-3xl font-bold">Pending</span>
      </div>
      <ProgressClockSVGIcon className={styles.cardIcon} />
    </div>
  );
}
